'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KeywordSearchBoxPanel = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = require('react-router');

var _deep = require('helpers/deep');

var _PanelSection = require('./PanelSection');

var _NoMatches = require('./Items/NoMatches');

var _Favorites = require('./Items/Favorites');

var _Activity = require('./Items/Activity');

var _Link = require('./Items/Link');

var _Venue = require('./Items/Venue');

var _Loader = require('./Loader');

var _SearchBox = require('./SearchBox.constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KeywordSearchBoxPanel = exports.KeywordSearchBoxPanel = function (_Component) {
  (0, _inherits3.default)(KeywordSearchBoxPanel, _Component);

  function KeywordSearchBoxPanel() {
    var _ref;

    var _temp, _this, _this3, _ret;

    (0, _classCallCheck3.default)(this, KeywordSearchBoxPanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = _this = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref = KeywordSearchBoxPanel.__proto__ || (0, _getPrototypeOf2.default)(KeywordSearchBoxPanel)).call.apply(_ref, [this].concat(args))), _this3), _this3.renderLink = function (link, highlighted, itemProps) {
      return _react2.default.createElement(_Link.Link, (0, _extends3.default)({
        to: link.to,
        label: link.label,
        key: 'links',
        highlighted: highlighted
      }, itemProps));
    }, _this3.renderFavorite = function (_, highlighted, itemProps) {
      return _react2.default.createElement(_Favorites.Favorites, (0, _extends3.default)({
        key: 'faves',
        highlighted: highlighted
      }, itemProps));
    }, _this3.renderVenue = function (venue, highlighted, itemProps) {
      return _react2.default.createElement(_Venue.Venue, (0, _extends3.default)({
        searchId: venue.search_id,
        key: venue.id,
        name: venue.name,
        subtitle: venue.subtitle || venue.neighborhood,
        highlighted: highlighted,
        onRemoveClick: _this.props.onRemoveItem
      }, itemProps));
    }, _this3.renderActivity = function (activity, highlighted, itemProps) {
      return _react2.default.createElement(_Activity.Activity, (0, _extends3.default)({
        searchId: activity.search_id,
        key: activity.id,
        name: activity.name,
        vertical: activity.vertical,
        highlighted: highlighted,
        onRemoveClick: _this.props.onRemoveItem
      }, itemProps));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this3, _ret);
  }

  (0, _createClass3.default)(KeywordSearchBoxPanel, [{
    key: 'getRenderMethodForItem',
    value: function getRenderMethodForItem(_ref2) {
      var _ITEM_TYPES$venue$ITE;

      var type = _ref2.type;

      return (_ITEM_TYPES$venue$ITE = {}, (0, _defineProperty3.default)(_ITEM_TYPES$venue$ITE, _SearchBox.ITEM_TYPES.venue, this.renderVenue), (0, _defineProperty3.default)(_ITEM_TYPES$venue$ITE, _SearchBox.ITEM_TYPES.activity, this.renderActivity), (0, _defineProperty3.default)(_ITEM_TYPES$venue$ITE, _SearchBox.ITEM_TYPES.favorites, this.renderFavorite), (0, _defineProperty3.default)(_ITEM_TYPES$venue$ITE, _SearchBox.ITEM_TYPES.links, this.renderLink), _ITEM_TYPES$venue$ITE)[type];
    }
  }, {
    key: 'getSections',
    value: function getSections() {
      var _props = this.props,
          hasQuery = _props.hasQuery,
          venues = _props.venues,
          activities = _props.activities,
          history = _props.history,
          isLoggedIn = _props.isLoggedIn,
          favoritesEnabled = _props.favoritesEnabled;


      var sections = [];
      var path = (0, _deep.deepExtract)('pathname', _reactRouter.browserHistory.getCurrentLocation(), '');

      if (!path.startsWith('/search')) {
        sections.push({
          key: 'links',
          items: [{
            to: 'search',
            type: 'links',
            name: 'Show all classes',
            label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'search.panel.show-all-classes', defaultMessage: 'Show all classes' })
          }]
        });
      }

      if (!hasQuery && history.length) {
        sections.push({
          key: 'history',
          items: history
        });
      }

      if (activities.length) {
        sections.push({
          key: 'activities',
          title: hasQuery ? _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'search.panel.matched-activities',
            defaultMessage: 'Activities'
          }) : _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'search.panel.popular-activities',
            defaultMessage: 'Popular activities'
          }),
          items: activities
        });
      }

      if (favoritesEnabled && isLoggedIn) {
        sections.push({
          key: 'favorites',
          items: [{ id: 'favorites', type: _SearchBox.ITEM_TYPES.favorites, name: 'Your favorites' }]
        });
      }

      if (venues.length) {
        sections.push({
          key: 'venues',
          title: hasQuery ? _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'search.panel.matched-venues',
            defaultMessage: 'Venues'
          }) : _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'search.panel.popular-venues',
            defaultMessage: 'Popular venues'
          }),
          items: venues
        });
      }

      return sections;
    }
  }, {
    key: 'renderResults',
    value: function renderResults() {
      var _this2 = this;

      var _props2 = this.props,
          getItemProps = _props2.getItemProps,
          highlightedIndex = _props2.highlightedIndex;


      var sections = this.getSections();
      var indexStart = 0;

      return _react2.default.createElement(
        _react.Fragment,
        null,
        sections.map(function (_ref3) {
          var key = _ref3.key,
              title = _ref3.title,
              items = _ref3.items;

          var indexBase = indexStart;
          indexStart += items.length;
          return _react2.default.createElement(
            _PanelSection.PanelSection,
            { key: key, title: title },
            items.map(function (item, i) {
              return _this2.getRenderMethodForItem(item)(item, indexBase + i === highlightedIndex, getItemProps({ item: item }));
            })
          );
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          hasResults = _props3.hasResults,
          isLoading = _props3.isLoading;


      return _react2.default.createElement(
        'div',
        { className: 'dropdown searchbox__panel' },
        _react2.default.createElement(
          'div',
          { className: 'dropdown__content' },
          hasResults ? this.renderResults() : _react2.default.createElement(
            _PanelSection.PanelSection,
            null,
            isLoading ? _react2.default.createElement(_Loader.Loader, null) : _react2.default.createElement(_NoMatches.NoMatches, null)
          )
        )
      );
    }
  }]);
  return KeywordSearchBoxPanel;
}(_react.Component);

KeywordSearchBoxPanel.propTypes = {
  onRemoveItem: _propTypes2.default.func.isRequired,
  getItemProps: _propTypes2.default.func.isRequired,
  highlightedIndex: _propTypes2.default.number,
  isLoading: _propTypes2.default.bool.isRequired,
  isLoggedIn: _propTypes2.default.bool.isRequired,
  favoritesEnabled: _propTypes2.default.bool.isRequired,
  hasQuery: _propTypes2.default.bool.isRequired,
  hasResults: _propTypes2.default.bool.isRequired,
  venues: _propTypes2.default.array.isRequired,
  activities: _propTypes2.default.array.isRequired,
  history: _propTypes2.default.array.isRequired
};